import getHelper from '../../../services/getHelper';

import MentoringSession from '../types/MentoringSession';
import MentoringSessionCompletion from '../types/MentoringSessionCompletion';
import MentoringSessionCancelation from '../types/MentoringSessionCancelation';

export default getHelper<MentoringSession>('/mentoring-sessions/:id', {
  complete: getHelper<MentoringSessionCompletion>('/complete'),
  cancel: getHelper<MentoringSessionCancelation>('/cancel'),
});
